import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, CheckboxRequiredValidator } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Account, AccountMessage, AccountStatus, AccountUpdate } from 'src/app/models/admModel/account.model';
import { AccountService } from 'src/app/shared/services/admServices/accounts.service';
import { SharedService } from 'src/app/shared/services/sharedServices/shared.service';

declare var require
const Swal = require('sweetalert2')

@Component({
  selector: 'adm-edit-publisher-component',
  templateUrl: './edit-publisher-component.html',
  styleUrls: ['./edit-publisher-component.scss']
})

export class editpublisherComponent implements OnInit {
  passwordForm: FormGroup;
  profileForm: FormGroup;
  countryData: any;
  flag: any;
  show: boolean;

  status: string;
  statusCol: any;
  btnLockName: any;
  btnLockColor: any;
  btnRegisterDis: any;
  btnChgpassDis: any;
  accRegistered: any; //registered, active, locked, chgpass
  accLocked: any;
  currentAccount = new Account();
  currentAccountStatus = new AccountStatus();
  currentAccountUpdate = new AccountUpdate();
  currentAccountMessage = new AccountMessage();
  changeCountry: boolean;
  roles: any[] = [];
  rolesName: string[] = [];
  checkAdminStat: boolean;
  checkPublisherStat: boolean;
  urlImage: any;

  defaultPayoutTermList = [
    { value: 1, label: 'every week' },
    { value: 2, label: 'biweekly' },
    { value: 3, label: 'every three weeks' },
    { value: 4, label: 'every four weeks' },
  ];
  
  constructor(
    private fbpro: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
    private accountService: AccountService,
    private sharedServices: SharedService)
    {

    }

    ngOnInit() {
      this.getAccount(this.route.snapshot.params?.['id']);
      this.getCountries();

      this.createProfileForm();
    }

    getCountries(): void {
      this.sharedServices.getAllCountries()
      .subscribe(
       data => {
         this.countryData = data.data.countries;
       },
       error => {
         console.log(error);
       });
    }

  createProfileForm(){
    this.profileForm = this.fbpro.group({
      company: [''],
      checkAdmin: [{value: false}],
      checkPublisher: [{value: false}],
      tax: [''],
      userName: [this.currentAccount.username, Validators.required],
      email: [this.currentAccount.email, Validators.required],
      firstName: [this.currentAccount.firstName, Validators.required],
      lastName: [this.currentAccount.lastName, Validators.required],
      street: ['', Validators.required],
      cityName: ['', Validators.required],
      zip: ['', Validators.required],
      country: [null, Validators.required],
      payterm: [ null, Validators.required],
      rate: [null, Validators.required],
      notes: [null]
    });
  }

  setProfileForm(){
    this.profileForm.setValue({
      userName: this.currentAccount.username,
      firstName: this.currentAccount.firstName,
      lastName: this.currentAccount.lastName,
      email: this.currentAccount.email,
      company: this.currentAccount.company,
      tax: this.currentAccount.tax,
      street: this.currentAccount.address,
      zip: this.currentAccount.zipCode,
      cityName: this.currentAccount.city,
      country: this.currentAccount.country.id,
      payterm: this.currentAccount.payoutTerm.id,
      rate: this.currentAccount.rate,
      notes: this.currentAccount.about,
      checkAdmin: this.checkAdminStat,
      checkPublisher: this.checkPublisherStat
    });
    this.flag = this.currentAccount.country.alpha2Code;
  }

  getAccount(id: string): void {
    this.accountService.getAccount(id)
      .subscribe(
        data => {
          this.currentAccount = data.data;
          if(this.currentAccount.profileImage==null)
            this.urlImage = '../../../../../assets/images/user/user2.png'
          else
            this.urlImage = this.currentAccount.profileImage;

          for(let i=0;i<data.data.roles.length;i++)
            this.rolesName[i]=data.data.roles[i].name

          if(this.rolesName.includes('ROLE_ADMIN'))
            this.checkAdminStat=true;
          else
            this.checkAdminStat=false;

          if(this.rolesName.includes('ROLE_PUBLISHER'))
            this.checkPublisherStat=true;
          else
            this.checkPublisherStat=false;

          this.show = this.checkPublisherStat;
          this.setProfileForm();
        },
        error => {
          console.log(error);
        });
  }

  onUpdate() {
    this.currentAccountUpdate.username = this.profileForm.value['userName'];
    this.currentAccountUpdate.firstName = this.profileForm.value['firstName'];
    this.currentAccountUpdate.lastName = this.profileForm.value['lastName'];
    this.currentAccountUpdate.company = this.profileForm.value['company'];
    this.currentAccountUpdate.profileImage = null;
    this.currentAccountUpdate.tax = this.profileForm.value['tax'];
    this.currentAccountUpdate.email = this.profileForm.value['email'];
    this.currentAccountUpdate.city = this.profileForm.value['cityName'];
    this.currentAccountUpdate.zipCode = this.profileForm.value['zip'];
    this.currentAccountUpdate.countryId = this.profileForm.value['country'];
    if(this.profileForm.value['checkPublisher'] && this.profileForm.value['checkAdmin'])
    {
      // obie role wybrane
      this.currentAccountUpdate.roleIds[0] = 1;
      this.currentAccountUpdate.roleIds[1] = 2;
    }
    else
    {
      // tylko jedna jakaś rola
      if(this.profileForm.value['checkPublisher'] || this.profileForm.value['checkAdmin'])
      {
        // jakaś rola ustawiona
        if(this.profileForm.value['checkPublisher'])
          this.currentAccountUpdate.roleIds[0] = 2;
        if(this.profileForm.value['checkAdmin'])
          this.currentAccountUpdate.roleIds[0] = 1;
      }
      else
        // zabezpieczenie jeżeli nic nie zostanie wybrane to zawsze przypisuje publishera
        this.currentAccountUpdate.roleIds[0] = 2;
    }
    this.currentAccountUpdate.about = this.profileForm.value['notes'];
    this.currentAccountUpdate.address = this.profileForm.value['street'];
    this.currentAccountUpdate.rate = this.profileForm.value['rate'];
    this.currentAccountUpdate.paymentTerm = Number(this.profileForm.value['payterm']);

    this.accountService.updateAccount(this.currentAccount.id, this.currentAccountUpdate)
    .subscribe(
      data => {
        console.log(data);
        this.toastrService.success('Profile data updated.', 'Success !');
      },
      err => {
        console.log("ERR:", err);
        this.toastrService.error(err.error.errors[0].message, 'Error !');
      });

  }

  onSend(){

    this.accountService.sendmailAccount(this.currentAccount.id, this.currentAccountMessage)
    .subscribe(
      response => {
        console.log(response);
        this.toastrService.success('Message sent.', 'Success !');
        this.currentAccountMessage.messageToSent="";
      },
      error => {
        console.log(error);
      });

  }

  // button zmieniający status na Chgpass
  onPass(){
    this.currentAccount.status = 4;
    this.currentAccountStatus.statusId = 4;
    this.accountService.updateAccountStatus( this.currentAccount.id, this.currentAccountStatus)
    .subscribe(
      response => {
        this.toastrService.warning('Account have to change password.', 'Warning !');
      },
      error => {
        console.log(error);
      });
  }

  // button zmieniający status z Registered na Active
  onRegister(){
    this.currentAccount.status = 1;
    this.currentAccountStatus.statusId = 1;
    this.accountService.updateAccountStatus( this.currentAccount.id, this.currentAccountStatus)
    .subscribe(
      response => {
        this.toastrService.success('Account has been activated.', 'Success !');
      },
      error => {
        console.log(error);
      });
  }

  // button zmieniający status na Locked lub Active
  onLock(){
    // status=2 Locked
    if(this.currentAccount.status == 2)
    {
      this.currentAccount.status= 1;
      this.currentAccountStatus.statusId = 1;
      this.accountService.updateAccountStatus( this.currentAccount.id, this.currentAccountStatus)
      .subscribe(
        response => {
          this.toastrService.success('Account has been activated.', 'Success !');
        },
        error => {
          console.log(error);
        });
    }
    else
    {
      this.currentAccount.status = 2;
      this.currentAccountStatus.statusId = 2;
      this.accountService.updateAccountStatus( this.currentAccount.id, this.currentAccountStatus)
      .subscribe(
        response => {
          this.toastrService.warning('Account has been locked.', 'Warning !');
        },
        error => {
          console.log(error);
        });
    }
  }

  onDelete(){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {

        this.accountService.deleteAccount(this.currentAccount.id)
        .subscribe(
          response => {
            console.log(response);
            Swal.fire(
              'Deleted!',
              'Your file has been deleted.',
              'success'
            )
            this.router.navigate(['/adm/publishers']);
          },
          error => {
            console.log(error);
          });

      }
    })
  }

  setPublisher(event){
    if(this.profileForm.value['checkPublisher'])
      this.show=true;
    else
      this.show=false;

  }

  setFlag(event){
    this.flag = this.countryData[this.profileForm.value['country']-1].alpha2Code;
  }

  onCancel(){
    this.router.navigate(['/adm/publishers']);
  }

}
